import React, {useEffect, useState} from 'react'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import Tabs, {Tab} from 'react-best-tabs'
import {Overview} from '../components/Overview'
import {People} from '../components/People'
import {Investments} from '../components/Investments'
import {Investors} from '../components/Investors'
import {BoardMembers} from '../components/BoardMembers'
import {Updates} from '../components/Updates'
import {useAuth} from '../../auth'
import {
  getAllBoardAdvisors,
  getAllInvestment,
  getAllInvestors,
  getAllPeople,
  getCompanyData,
  getIndustryFocus,
  getPublicCompanyPage,
  updateCompanyPublishStatus,
} from '../core/_requests'
import {toast} from 'react-toastify'
import {InvestorUpdatesModel} from '../../investor-updates/core/_models'
import {getAllInvestorUpdatesAPI} from '../../investor-updates/core/_request'
import {AddCompanyModal} from '../components/AddCompanyModal'
import {GeneralConfirmationModal} from '../../widgets/components/GeneralConfirmationModal'
import {useLocation, useParams} from 'react-router-dom'
// import {Spinner} from '../../widgets/components/General/Spinner'
import Footer from '../components/Footer'
import {roleValues} from '../../../core/_constants'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

export const CompanyDetailsPage = () => {
  const {formatMessage} = useIntl()
  const [companyPeopleData, setCompanyPeopleData] = useState<any>([])
  const {companyId, role, currentUser} = useAuth()
  const [searchInvestorUser, setSearchInvestorUser] = useState('')
  const [sortOrderUser, setSortOrderUser] = useState('')
  const [sortByUser, setSortByUser] = useState('')
  const [peopleApiLoading, setPeopleApiLoading] = useState(false)
  const [sortInvestmentBy, setSortInvestmentBy] = useState('')
  const [sortInvestmentOrder, setSortInvestmentOrder] = useState('')
  const [investmentApiLoading, setInvestmentApiLoading] = useState(false)
  const [companyInvestmentData, setCompanyInvestmentData] = useState<any>([])
  const [sortInvestorsBy, setSortInvestorsBy] = useState('')
  const [sortInvestorsOrder, setSortInvestorsOrder] = useState('')
  const [investorsApiLoading, setInvestorsApiLoading] = useState(false)
  const [companyInvestorsData, setCompanyInvestorsData] = useState<any>([])
  const [boardAdvisorsApiLoading, setBoardAdvisorsApiLoading] = useState(false)
  const [companyBoardAdvisorsData, setCompanyBoardAdvisorsData] = useState<any>([])
  const [investorUpdatesData, setInvestorUpdatesData] = useState<
    InvestorUpdatesModel[] | undefined
  >([])
  const [investorUpdatesApiLoading, setInvestorUpdatesApiLoading] = useState(false)
  const [companyApiLoading, setCompanyApiLoading] = useState(false)
  const [companyPageData, setCompanyPageData] = useState<any>([])
  const [totalFunds, setTotalFunds] = useState(0)
  const [firstDate, setFirstDate] = useState<any>()
  const [leadInvestors, setLeadInvestors] = useState<any>([])
  const [showCompanyModal, setShowCompanyModal] = useState(false)
  const [companyImgName, setCompanyImgName] = useState<string>()
  const [showGeneralModal, setGeneralShowModal] = useState(false)
  const [generalLoading, setGeneralLoading] = useState(false)
  const [industryFocusData, setIndustryFocusData] = useState<any>([])
  const [publicStatus, setPublicStatus] = useState<any>(undefined)
  const [publicCompanyPageLoading, setPublicCompanyPageLoading] = useState(false)
  const {slug} = useParams()
  const location = useLocation()

  useEffect(() => {
    if (location?.pathname?.split('/')[2] === 'public') {
      setPublicStatus(true)
    } else {
      setPublicStatus(false)
    }
  }, [location])
  const getAllCompanyPeople = async () => {
    try {
      setPeopleApiLoading(true)
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getAllPeople(companyId, searchInvestorUser, sortByUser, sortOrderUser)
        if (success) {
          setPeopleApiLoading(false)
          setCompanyPeopleData(data)
        } else {
          setPeopleApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      setPeopleApiLoading(false)
      console.log(err)
    }
  }

  const getAllCompanyInvestment = async () => {
    try {
      setInvestmentApiLoading(true)
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getAllInvestment(companyId, sortInvestmentBy, sortInvestmentOrder)
        if (success) {
          setInvestmentApiLoading(false)
          setCompanyInvestmentData(data)
        } else {
          setInvestmentApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      setInvestmentApiLoading(false)
      console.log(err)
    }
  }

  const getAllCompanyInvestors = async () => {
    try {
      setInvestorsApiLoading(true)
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getAllInvestors(companyId, sortInvestorsBy, sortInvestorsOrder)
        if (success) {
          setInvestorsApiLoading(false)
          setCompanyInvestorsData(data)
        } else {
          setInvestorsApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      setInvestorsApiLoading(false)
      console.log(err)
    }
  }

  const getAllCompanyBoardAdvisors = async () => {
    try {
      setBoardAdvisorsApiLoading(true)
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getAllBoardAdvisors(companyId)
        if (success) {
          setBoardAdvisorsApiLoading(false)
          setCompanyBoardAdvisorsData(data)
        } else {
          setBoardAdvisorsApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      setBoardAdvisorsApiLoading(false)
      console.log(err)
    }
  }
  const getAllInvestorUpdate = async () => {
    try {
      setInvestorUpdatesApiLoading(true)
      if (companyId) {
        const {
          data: {
            data: {investorUpdates},
            success,
            errors,
          },
        }: any = await getAllInvestorUpdatesAPI(
          +companyId!,
          null,
          null,
          undefined,
          undefined,
          'PUBLISHED'
        )

        if (success) {
          setInvestorUpdatesData([...investorUpdates])
          setInvestorUpdatesApiLoading(false)
        } else {
          setInvestorUpdatesApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      setInvestorUpdatesApiLoading(false)
      console.log(err)
    }
  }

  const getCompanyPageData = async () => {
    try {
      setCompanyApiLoading(true)
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getCompanyData(companyId)
        if (success) {
          setCompanyApiLoading(false)
          setCompanyPageData(data)
        } else {
          setCompanyApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      setCompanyApiLoading(false)
      console.log(err)
    }
  }
  const getAllIndustryFocus = async (companyId: number) => {
    try {
      const {
        data: {data, success, errors},
      } = await getIndustryFocus(companyId)
      if (success) {
        setIndustryFocusData(data)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }
  const handlePublishStatus = async () => {
    try {
      setGeneralLoading(true)
      if (companyId) {
        let payload
        if (companyPageData?.published) {
          payload = {
            published: false,
          }
        } else {
          payload = {
            published: true,
          }
        }
        const {
          data: {success, errors},
        } = await updateCompanyPublishStatus(companyId, payload)
        if (success) {
          setGeneralLoading(false)
          setGeneralShowModal(false)
          getCompanyPageData()
          toast.success(formatMessage({id: 'Company publish status updated successfully'}))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateCompanyPublishStatusSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                published: payload?.published,
              },
            },
          })
        } else {
          setGeneralLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateCompanyPublishStatusFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                published: payload?.published,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setGeneralLoading(false)
      console.log(err)
    }
  }
  const getPublicCompanyPageData = async (slug: string) => {
    try {
      setPublicCompanyPageLoading(true)
      const payload = {
        people: {
          search: searchInvestorUser,
          sort_by: sortByUser,
          sort_order: sortOrderUser,
        },
        investor: {
          sort_by: sortInvestorsBy,
          sort_order: sortInvestorsOrder,
        },
        investment: {
          sort_by: sortInvestmentBy,
          sort_order: sortInvestmentOrder,
        },
      }
      const {
        data: {
          data: {
            companyPageData: companyPageDataValue,
            companyPagePeopleData,
            companyPageInvestorData,
            companyPageInvestmentData,
            companyPageIndustryFocusData,
            companyPageBoardMemberData,
            investorUpdateData,
          },
          success,
          errors,
        },
      } = await getPublicCompanyPage(slug, payload)
      if (success) {
        setCompanyPageData(companyPageDataValue)
        setCompanyPeopleData(companyPagePeopleData)
        setCompanyInvestorsData(companyPageInvestorData)
        setCompanyInvestmentData(companyPageInvestmentData)
        setCompanyBoardAdvisorsData(companyPageBoardMemberData)
        setInvestorUpdatesData(investorUpdateData)
        setIndustryFocusData(companyPageIndustryFocusData)
        setPublicCompanyPageLoading(false)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        setPublicCompanyPageLoading(false)
      }
    } catch (err) {
      console.log(err)
      setPublicCompanyPageLoading(false)
    }
  }
  useEffect(() => {
    // if (
    //   publicStatus === false &&
    //   role &&
    //   (role === roleValues.OWNER || role === roleValues.ADMIN || role === roleValues.IRM)
    // ) {

    if (publicStatus === false && role && role === roleValues.OWNER) {
      getAllInvestorUpdate()
    }
  }, [companyId, publicStatus, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (publicStatus === false && role && role === roleValues.OWNER) {
      getAllCompanyPeople()
    }
  }, [companyId, searchInvestorUser, sortByUser, sortOrderUser, publicStatus, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if (
    //   publicStatus === false &&
    //   role &&
    //   (role === roleValues.OWNER || role === roleValues.ADMIN || role === roleValues.IRM)
    // ) {

    if (publicStatus === false && role && role === roleValues.OWNER) {
      getAllCompanyInvestment()
    }
  }, [companyId, sortInvestmentBy, sortInvestmentOrder, publicStatus, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if (
    //   publicStatus === false &&
    //   role &&
    //   (role === roleValues.OWNER || role === roleValues.ADMIN || role === roleValues.IRM)
    // ) {

    if (publicStatus === false && role && role === roleValues.OWNER) {
      getAllCompanyInvestors()
    }
  }, [companyId, sortInvestorsBy, sortInvestorsOrder, publicStatus, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if (
    //   publicStatus === false &&
    //   role &&
    //   (role === roleValues.OWNER || role === roleValues.ADMIN || role === roleValues.IRM)
    // ) {

    if (publicStatus === false && role && role === roleValues.OWNER) {
      getAllCompanyBoardAdvisors()
    }
  }, [companyId, publicStatus, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (publicStatus === false && role && role === roleValues.OWNER) {
      getCompanyPageData()
    }
  }, [companyId, publicStatus, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if (
    //   companyId &&
    //   publicStatus === false &&
    //   (role === roleValues.OWNER || role === roleValues.ADMIN || role === roleValues.IRM)
    // ) {

    if (companyId && publicStatus === false && role === roleValues.OWNER) {
      getAllIndustryFocus(companyId)
    }
  }, [companyId, publicStatus]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (publicStatus && slug) {
      getPublicCompanyPageData(slug)
    }
  }, [slug, publicStatus]) // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = publicStatus === false ? companyApiLoading : publicCompanyPageLoading

  return (
    <>
      <div className={`px-5 company-page ${publicStatus && 'mt-6 company-page-footer mb-20'}`}>
        {/* {(publicStatus === false ? companyApiLoading : publicCompanyPageLoading) ? (
          <Spinner />
        ) : null} */}
        <div className='card w-100 p-4 p-md-7 d-flex flex-md-row flex-column justify-content-between company-page-top-section company-page-dark'>
          <div className='col-md-8 col-12'>
            {isLoading ? (
              <div className='d-flex'>
                <Skeleton
                  width={60}
                  height={60}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                <div style={{marginLeft: '0.5rem', width: '100%'}}>
                  <Skeleton
                    width='50%'
                    height={60}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>
              </div>
            ) : (
              <div className='d-flex gap-4 rounded-xl'>
                <DisplayImage
                  imgName={companyPageData?.file?.name}
                  className='rounded-xl'
                  width='120px'
                  height={120}
                  alt={formatMessage({id: 'investor logo'})}
                  fit='contain'
                />
                <div className='w-100 ml-2'>
                  <div className='d-flex gap-3'>
                    <h2>{companyPageData?.name ? companyPageData?.name : 'NA'}</h2>
                    <span
                      className={`badge ${
                        companyPageData?.published ? 'badge-light-success' : 'badge-light-danger'
                      } button-radius`}
                    >
                      {formatMessage({
                        id: companyPageData?.published ? 'Published' : 'Unpublished',
                      })}
                    </span>
                  </div>
                  <div className='pe-4 pt-2'>
                    <p>{companyPageData?.description ? companyPageData?.description : 'NA'}</p>
                  </div>
                </div>
              </div>
            )}
            {isLoading ? (
              <Skeleton
                height={30}
                style={{width: '50%'}}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ) : (
              <div className='d-flex flex-md-row flex-column mt-4'>
                <div
                  className={`d-flex gap-2 pt-2 col-3 mt-md-0 mt-5 ${
                    !companyPageData?.linkedin &&
                    !companyPageData?.twitter &&
                    !companyPageData?.facebook &&
                    !companyPageData?.instagram &&
                    'd-none'
                  }`}
                >
                  {companyPageData?.linkedin && (
                    <a href={companyPageData.linkedin} target='_blank' rel='noreferrer'>
                      <img
                        src={toAbsoluteUrl('/media/icons/investor/LinkedIn.svg')}
                        height={20}
                        alt={formatMessage({id: 'LinkedIn'})}
                      />
                    </a>
                  )}
                  {companyPageData?.twitter && (
                    <a href={companyPageData.twitter} target='_blank' rel='noreferrer'>
                      <img
                        src={toAbsoluteUrl('/media/icons/investor/Twitter.svg')}
                        height={15}
                        alt={formatMessage({id: 'Twitter'})}
                      />
                    </a>
                  )}
                  {companyPageData?.facebook && (
                    <a href={companyPageData.facebook} target='_blank' rel='noreferrer'>
                      <img
                        src={toAbsoluteUrl('/media/icons/investor/Facebook.svg')}
                        height={20}
                        alt={formatMessage({id: 'Facebook'})}
                      />
                    </a>
                  )}
                  {companyPageData?.instagram && (
                    <a href={companyPageData.instagram} target='_blank' rel='noreferrer'>
                      <img
                        src={toAbsoluteUrl('/media/icons/investor/Instagram.svg')}
                        height={20}
                        alt={formatMessage({id: 'Instagram'})}
                      />
                    </a>
                  )}
                </div>
                <div className='d-flex gap-md-15 gap-5 mt-md-0 mt-5'>
                  <div className='d-flex align-items-center gap-3'>
                    <img src={toAbsoluteUrl('/media/icons/investor/websiteLogo.svg')} alt='' />
                    <div>
                      {companyPageData?.website ? (
                        <a href={companyPageData?.website} target='_blank' rel='noreferrer'>
                          {companyPageData?.website}
                        </a>
                      ) : (
                        'NA'
                      )}
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-3'>
                    <img src={toAbsoluteUrl('/media/icons/investor/Location.svg')} alt='location' />
                    <div>
                      {companyPageData?.country?.country_name
                        ? companyPageData?.country?.country_name
                        : 'NA'}
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-3'>
                    <img src={toAbsoluteUrl('/media/icons/investor/people.svg')} alt='' />
                    <div>{companyPeopleData?.length}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {publicStatus === false && (
            <div className='w-100 flex-md-row flex-column d-flex gap-3 h-25 mt-md-0 mt-5 p-2 justify-content-md-end'>
              {isLoading ? (
                <>
                  <Skeleton
                    width={100}
                    height={36}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                  <Skeleton
                    width={100}
                    height={36}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                  <Skeleton
                    width={100}
                    height={36}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </>
              ) : (
                <>
                  <button
                    className='btn bg-primary custom-button-property justify-content-center py-3 text-white font-weight-400 font-size-13 height-36 d-flex align-items-center'
                    onClick={() => setGeneralShowModal(true)}
                  >
                    {formatMessage({
                      id: companyPageData?.published ? 'Unpublish Page' : 'Publish Page',
                    })}
                  </button>
                  {companyPageData?.published && (
                    <button
                      className='btn bg-light custom-button-property justify-content-center text-muted font-weight-400 font-size-13 height-36 d-flex align-items-center'
                      onClick={() =>
                        window.open(`/company-page/public/${companyPageData?.slug}`, '_blank')
                      }
                    >
                      {formatMessage({id: 'Preview'})}
                    </button>
                  )}

                  <button
                    className='btn bg-light custom-button-property justify-content-center text-muted font-weight-400 font-size-13 height-36 d-flex align-items-center'
                    onClick={() => setShowCompanyModal(true)}
                  >
                    {formatMessage({id: 'Edit'})}
                  </button>
                </>
              )}
            </div>
          )}
        </div>

        <div className='mb-n3 tabs-container'>
          <Tabs
            activeTab={1}
            className=''
            ulClassName='w-100 text-muted dark-border setting-tabs bg-white px-2 company-page-dark'
            activityClassName='bg-primary'
          >
            <Tab title={formatMessage({id: 'Overview'})} className='mr-3 mt-2'>
              <div className='mt-6'>
                <Overview
                  companyPageData={companyPageData}
                  setTotalFunds={setTotalFunds}
                  totalFunds={totalFunds}
                  setFirstDate={setFirstDate}
                  firstDate={firstDate}
                  companyInvestmentData={companyInvestmentData}
                  setLeadInvestors={setLeadInvestors}
                  leadInvestors={leadInvestors}
                  companyInvestorsData={companyInvestorsData}
                  getCompanyPageData={getCompanyPageData}
                  industryFocusData={industryFocusData}
                  getAllIndustryFocus={getAllIndustryFocus}
                  publicStatus={publicStatus}
                  companyApiLoading={companyApiLoading}
                />
              </div>
            </Tab>
            <Tab title={formatMessage({id: 'People'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <People
                  setSearchInvestorUser={setSearchInvestorUser}
                  setSortOrderUser={setSortOrderUser}
                  setSortByUser={setSortByUser}
                  companyPeopleData={companyPeopleData}
                  getAllCompanyPeople={getAllCompanyPeople}
                  peopleApiLoading={peopleApiLoading}
                  publicStatus={publicStatus}
                  publicCompanyPageLoading={publicCompanyPageLoading}
                />
              </div>
            </Tab>
            <Tab title={formatMessage({id: 'Investments'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <Investments
                  getAllCompanyInvestment={getAllCompanyInvestment}
                  setSortInvestmentBy={setSortInvestmentBy}
                  setSortInvestmentOrder={setSortInvestmentOrder}
                  investmentApiLoading={investmentApiLoading}
                  companyInvestmentData={companyInvestmentData}
                  companyPageData={companyPageData}
                  setTotalFunds={setTotalFunds}
                  totalFunds={totalFunds}
                  setFirstDate={setFirstDate}
                  firstDate={firstDate}
                  publicStatus={publicStatus}
                  publicCompanyPageLoading={publicCompanyPageLoading}
                />
              </div>
            </Tab>
            <Tab title={formatMessage({id: 'Investors'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <Investors
                  getAllCompanyInvestors={getAllCompanyInvestors}
                  setSortInvestorsBy={setSortInvestorsBy}
                  setSortInvestorsOrder={setSortInvestorsOrder}
                  investorsApiLoading={investorsApiLoading}
                  companyInvestorsData={companyInvestorsData}
                  companyPageData={companyPageData}
                  setLeadInvestors={setLeadInvestors}
                  leadInvestors={leadInvestors}
                  publicStatus={publicStatus}
                  publicCompanyPageLoading={publicCompanyPageLoading}
                />
              </div>
            </Tab>
            <Tab
              title={formatMessage({id: 'Board Members & Advisors'})}
              className='mr-3 mt-2 min-w-250px min-w-md-200px'
            >
              <div className='mt-3'>
                <BoardMembers
                  getAllCompanyBoardAdvisors={getAllCompanyBoardAdvisors}
                  boardAdvisorsApiLoading={boardAdvisorsApiLoading}
                  companyBoardAdvisorsData={companyBoardAdvisorsData}
                  companyPageData={companyPageData}
                  publicStatus={publicStatus}
                  publicCompanyPageLoading={publicCompanyPageLoading}
                />
              </div>
            </Tab>
            <Tab title={formatMessage({id: 'Updates'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <Updates
                  investorUpdatesData={investorUpdatesData}
                  investorUpdatesApiLoading={investorUpdatesApiLoading}
                  publicCompanyPageLoading={publicCompanyPageLoading}
                  publicStatus={publicStatus}
                />
              </div>
            </Tab>
          </Tabs>
        </div>
        <AddCompanyModal
          showCompanyModal={showCompanyModal}
          setShowCompanyModal={setShowCompanyModal}
          setCompanyImgName={setCompanyImgName}
          companyImgName={companyImgName}
          companyPageData={companyPageData}
          getCompanyPageData={getCompanyPageData}
          companyApiLoading={companyApiLoading}
        />
        <GeneralConfirmationModal
          showGeneralModal={showGeneralModal}
          setGeneralShowModal={setGeneralShowModal}
          headingMessage={formatMessage({
            id: companyPageData?.published ? 'Unpublish Company Page' : 'Publish Company Page',
          })}
          description={formatMessage({
            id: companyPageData?.published
              ? 'Are you sure you want to Unpublish this Company Page?'
              : 'Are you sure you want to Publish this Company Page?',
          })}
          handleConfirm={handlePublishStatus}
          generalLoading={generalLoading}
          buttonText={formatMessage({
            id: companyPageData?.published ? 'Unpublish Page' : 'Publish Page',
          })}
        />
      </div>
      {publicStatus && <Footer />}
    </>
  )
}
